export default function Plan() {
    return (
        <div>
            <img src="/images/plan.png" alt="" className="w-full h-full object-contain"/>
        </div>
    )
}
